type MeasurementData = {
  id: number;
  ulid: string;
  from: number;
  values: number[];
};

export const mergeDataObjects = (objectsSortedByFrom: MeasurementData[]): number[] => {
  if (!objectsSortedByFrom || !objectsSortedByFrom.length) return [];

  const minFrom = objectsSortedByFrom[0].from;

  const lastObj = objectsSortedByFrom[objectsSortedByFrom.length - 1];
  const maxPosition = lastObj.from + lastObj.values.length;

  const resultLength = maxPosition - minFrom;
  const result = new Array(resultLength).fill(null);

  for (let i = 0; i < objectsSortedByFrom.length; i++) {
    const obj = objectsSortedByFrom[i];
    const offset = obj.from - minFrom;
    const values = obj.values;

    for (let j = 0; j < values.length; j++) {
      result[offset + j] = values[j];
    }
  }

  return result;
};
